import React from 'react';
import gif from '../Assets/Images/Untitled (3).gif'
const Loader = () => {
  return (
    <div id="preloader">
      <img height='600' width='600' src={gif} className='loading-loader' alt='loader'/>
      {/* <div data-loader="circle-side">
        </div> */}
        </div>
  );
};

export default Loader;
